<template>
  <div class="stripe-payment">
    <section style="position: relative">
      <section v-if="userType !== 'teams'">
        <div @click="scroll('left', 'plansWrapper')" class="arrow arrow__left">
          <v-icon>chevron_left</v-icon>
        </div>
        <div @click="scroll('right', 'plansWrapper')" class="arrow arrow__right">
          <v-icon>chevron_right</v-icon>
        </div>
      </section>

      <h4 class="text-xs-left mb-2" v-if="userType === 'teams'">Laufzeit & Kosten</h4>
      <h4 class="text-xs-left mb-2" v-else>
        Wähle zuerst ein passendes Swipe-Package aus.
      </h4>

      <div ref="plansWrapper" class="scrolling-wrapper-flexbox">
        <template v-if="userType !== 'teams'">
          <button
            v-for="plan in plans"
            @click="selectPlan(plan)"
            :key="plan.id"
            :class="[
              'plan-button',
              { 'plan-button-active': selectedPlan.id === plan.id },
              { 'most-selected-plan': plan.swipes === 25 },
            ]"
          >
            <strong style="font-size: 16px; font-weight: 800">{{ plan.name }}</strong
            ><br />
            <span v-html="`einmalig<BR>${plan.price}`"></span>
            <div v-if="plan.swipes === 25" class="most-selected">MEIST GEWÄHLT</div>
          </button>
        </template>
        <template v-else>
          <button
            v-for="plan in plans"
            @click="selectPlan(plan)"
            :key="plan.id"
            :class="[
              'plan-button',
              'plan-button-full',
              { 'plan-button-active': selectedPlan.id === plan.id },
            ]"
          >
            <div class="plan-button__block">
              <div>
                <strong style="font-size: 20px; font-weight: 800"
                  >{{ getRestSeisonTime() }} Monate</strong
                >
              </div>
              <div>
                <strong style="font-size: 16px; font-weight: 800; line-height: 18px"
                  >bis Saisonende</strong
                >
              </div>
              <div>
                <span v-html="'läuft automatisch am 30.06. ab'"></span>
              </div>
            </div>
            <div class="plan-button__block">
              <div>
                <strong style="font-size: 20px; font-weight: 800"
                  >{{ getRestPrice(plan) }}€</strong
                >
              </div>
              <div>
                <strong style="font-size: 16px; font-weight: 800; line-height: 18px"
                  >einmalige Zahlung</strong
                >
              </div>
              <div>
                <span v-html="'Kosten sind inkl. ges. MwSt.'"></span>
              </div>
            </div>
          </button>
        </template>
        <!-- scroll buffor -->
        <div style="min-width: 1px"></div>
      </div>

      <div class="small_text">
        <small v-if="userType !== 'teams'">
          *12 Monate Gültigkeit. | 365 Tage unbegrenzt swipen.
        </small>
      </div>

      <div v-if="userType === 'teams'">
        <h4 class="text-xs-left mt-2">
          Gib zuerst die Daten des Rechnungsempfängers ein.
        </h4>
        <v-form ref="form" v-model="userDataFormValid">
          <v-container>
            <v-layout>
              <v-flex>
                <v-text-field
                  color="green"
                  v-model="form.name"
                  :rules="nameRules"
                  label="Vereinsname / Firmenname (Sponsor)"
                  required
                  :disabled="formDisabled"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field
                  color="green"
                  v-model="form.email"
                  :rules="emailRules"
                  label="E-Mail-Adresse"
                  required
                  :disabled="formDisabled"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field
                  color="green"
                  v-model="form.contactPerson"
                  :rules="contactPersonRules"
                  label="Ansprechpartner"
                  required
                  :disabled="false"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field
                  color="green"
                  v-model="form.address.line1"
                  :rules="line1Rules"
                  label="Straße, Hausnummer"
                  required
                  :disabled="formDisabled"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs4>
                <v-text-field
                  color="green"
                  v-model="form.address.postal_code"
                  :rules="postalcodeRules"
                  label="PLZ"
                  required
                  :disabled="formDisabled"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  color="green"
                  v-model="form.address.city"
                  :rules="cityRules"
                  label="Ort"
                  required
                  :disabled="formDisabled"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-autocomplete
                  color="green"
                  :items="this.$store.state.nationalities"
                  style="padding-top: 2px"
                  :rules="countryRules"
                  item-text="item_text"
                  item-value="id"
                  v-model="form.address.country"
                  required
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <div style="color: #aaaaaa; font-size: 12px">
              Die Rechnung wird nach erfolgreicher Zahlung umgehend per E-Mail an den
              Rechnungsempfänger zugestellt.
            </div>
          </v-container>
        </v-form>
      </div>

      <div class="promo-section" v-if="userType === 'teams'">
        <h4 class="text-xs-left mt-2">Du hast einen Rabattcode?</h4>
        <v-text-field
          color="green"
          v-model="promoCodeInput"
          label="Dann kannst du ihn hier eingeben und aktivieren."
        >
          <template v-slot:append-outer>
            <button @click="checkCode" class="promo-button">
              <v-icon color="white" v-if="promoCodeIcon">{{ promoCodeIcon }}</v-icon>
              <span v-else>Code aktivieren</span>
            </button>
          </template>
        </v-text-field>

        <div v-if="promoCode" class="promo-info">
          {{ promoCode.coupon.name }}
        </div>
      </div>

      <section>
        <div
          @click="scroll('left', 'paymentsWrapper')"
          class="arrow arrow__left arrow__payment"
          :class="{ arrow__payment_team: userType === 'teams' }"
        >
          <v-icon>chevron_left</v-icon>
        </div>
        <div
          @click="scroll('right', 'paymentsWrapper')"
          class="arrow arrow__right arrow__payment"
          :class="{ arrow__payment_team: userType === 'teams' }"
        >
          <v-icon>chevron_right</v-icon>
        </div>
      </section>

      <h4 v-if="userType === 'teams'" class="text-xs-left mt-2">
        Wähle abschließend die bevorzugte Zahlungsart aus.
      </h4>
      <h4 v-else class="text-xs-left mt-2">
        Wähle abschließend deine bevorzugte Zahlungsart aus.
      </h4>

      <div
        ref="paymentsWrapper"
        v-if="!!selectedPlan.id"
        class="scrolling-wrapper-flexbox"
        style="margin: 10px auto"
      >
        <button
          v-for="(payment, index) in paymentMethods"
          :key="`payment-${index}`"
          :disabled="creatingStripeCustomer"
        >
          <img
            @click="selectPayment(payment)"
            :src="require(`@/assets/icons/payments/${payment.icon}.png`)"
            width="70"
            height="50"
            style="margin-right: 4px"
            :class="{
              'payment-selected': payment.component === activeComponent,
              'payment-disabled':
                !payment.active || (!userDataFormValid && userType === 'teams'),
            }"
          />
        </button>
        <!-- scroll buffor -->
        <div style="min-width: 1px"></div>
      </div>
    </section>

    <section v-if="activeComponent">
      <component
        :is="activeComponent"
        :customerData="customerData"
        :payButtonEnabled="
          !!selectedPlan.id ||
          (!!stripeCustomerId && userType === 'teams' && !!selectedPlan.id)
        "
        :stripeCustomerId="stripeCustomerId"
        :orderedItem="selectedPlan"
        @payment-successful="paymentSuccessful"
      />
    </section>
  </div>
</template>

<script>
import { isIOS, isMacOs, isChrome } from 'mobile-device-detect';
import { mapState } from 'vuex';
import Axios from 'axios';
import { db } from '@/db';
import {
  cloudFunctionsBackoffice,
  paymentPackages,
  paymentPackagesLeague,
} from '../../config';
import stripeHelper from '../../mixins/stripe-helper';

import Card from '../../components/stripe/Card';
import Iban from '../../components/stripe/Iban';
import Sofort from '../../components/stripe/Sofort';
import Giropay from '../../components/stripe/Giropay';
import MobileApple from '../../components/stripe/Mobile';
import MobileGoogle from '../../components/stripe/Mobile';
import Paypal from '../../components/paypal/Standard';

export default {
  name: 'stripe-payment',

  components: {
    Card,
    Iban,
    Sofort,
    Giropay,
    MobileApple,
    MobileGoogle,
    Paypal,
  },

  mixins: [stripeHelper],

  data() {
    return {
      paymentMethods: [],
      plans: [],
      activeComponent: undefined,
      email: '',
      selectedPlan: {},
      stripeCustomerId: null,
      creatingStripeCustomer: false,
      userDataFormValid: false,
      form: {
        email: '',
        name: '',
        address: {
          city: '',
          line1: '',
          line2: '',
          postal_code: '',
          country: 'DE',
        },
        contactPerson: '',
      },
      formDisabled: false,
      emailRules: [
        (v) => !!v || 'E-mail ist Pflichtfeld',
        (v) => /.+@.+/.test(v) || 'E-mail ist invalid',
      ],
      nameRules: [(v) => !!v || 'Name ist Pflichtfeld'],
      contactPersonRules: [(v) => !!v || 'Ansprechpartner ist Pflichtfeld'],
      line1Rules: [(v) => !!v || 'Strasse/Hausnummer ist Pflichtfeld'],
      postalcodeRules: [(v) => !!v || 'PLZ ist Pflichtfeld'],
      cityRules: [(v) => !!v || 'Ort ist Pflichtfeld'],
      countryRules: [(v) => !!v || 'Land ist Pflichtfeld'],
    };
  },

  computed: {
    ...mapState(['user_data', 'userType', 'payments']),

    customerData() {
      const name = this.userType === 'teams' ? this.form.name : this.user_data.name;
      return {
        email: this.email,
        name,
      };
    },
  },

  watch: {
    promoCode() {
      this.selectedPlan.promoPrice = this.getRestPrice(this.selectedPlan);
    },
    userDataFormValid(newVal) {
      this.formDisabled = newVal && !!this.stripeCustomerId;
    },
  },

  methods: {
    selectPlan(plan) {
      this.selectedPlan = plan;
      if (this.userType === 'teams') {
        this.selectedPlan.promoPrice = this.getRestPrice(plan);
      }

      this.$gtm.push({ event: 'product_click', product_name: plan.name });
    },

    async selectPayment(payment) {
      if (payment.component === 'Paypal' && payment.active) {
        this.activeComponent = payment.component;
      } else if (this.userType !== 'teams' && payment.active) {
        this.activeComponent = payment.component;
      } else if (!!this.selectedPlan.id && this.userDataFormValid) {
        this.creatingStripeCustomer = true;

        if (!this.stripeCustomerId) {
          this.$store.state.loading = true;
          const data = {
            ...this.form,
            accountId: this.user_data.id,
            accountType: this.userType,
          };

          const customerId = await this.createCustomer(data);
          this.stripeCustomerId = customerId;
          this.$store.state.loading = false;
        }

        this.activeComponent = payment.component;
        this.creatingStripeCustomer = false;
      } else {
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Bitte alle Rechnungsdaten angeben.',
        });
      }
      this.$gtm.push({
        event: 'add_to_cart',
        product_name: this.selectedPlan.name,
        payment_selected: payment.component,
      });
    },

    paymentSuccessful(payment) {
      // will not be executed if payment girocard or sofort
      // saved in stripepaymentprocess.vue
      const batch = db.batch();
      // update user swipes in firesotre
      const refLoggedUser = db.collection(this.userType).doc(this.user_data.id);

      if (this.userType === 'teams') {
        const saisonEndMonth = 6;
        const currentMonth = new Date().getMonth() + 1;
        const currentYear = new Date().getFullYear();
        const saisonEnd = currentMonth > saisonEndMonth ? currentYear + 1 : currentYear;

        batch.update(refLoggedUser, {
          leaguePackage: {
            activeToDate: saisonEnd,
            paid: +payment.paidPlan.promoPrice.replace('.', ''),
            boughtAt: Date.now(),
            boughtFor: this.getRestSeisonTime(),
            paidBy: payment.paidBy,
          },
        });
      } else {
        batch.update(refLoggedUser, { swipesLeft: payment.paidPlan.swipes });
      }

      // save payment in firestore
      const newPaymentRef = db.collection('payments').doc();
      const paymentData = {
        stripe_payment_id: payment.paymentId,
        account_type: this.userType,
        account_id: this.user_data.id,
        plan_details: payment.paidPlan,
        payment_method: payment.paidBy,
        timestamp: Date.now(),
      };
      batch.set(newPaymentRef, paymentData);

      // run batch
      batch
        .commit()
        .then(async () => {
          this.$gtm.push({
            event: 'purchase',
            product_name: this.selectedPlan.name,
            payment_selected: payment.paidPlan,
          });

          const data = {
            amount: Math.round(payment.paidPlan.value / 100).toFixed(2),
            email: this.user_data.email,
            affiliateId: this.user_data.affilliateID,
            ...paymentData,
          };

          await Axios({
            method: 'post',
            url: `${cloudFunctionsBackoffice}/newPayment`,
            headers: {
              'content-type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
            data: JSON.stringify(data),
          });

          this.$store.commit('setUserPayments', [paymentData, ...this.payments]);
          this.$store.commit({
            type: 'openSnackbar',
            text:
              this.userType === 'teams'
                ? 'Das Saisonticket ist jetzt aktiviert.'
                : 'Dein Swipe-Package ist jetzt aktiv.',
          });
        })
        .catch((err) => {
          this.$store.commit({
            type: 'openSnackbar',
            text: 'Ups, da ist etwas schief gelaufen',
          });
          console.log({ err });
        });
    },
  },

  created() {
    this.email = this.user_data.email;

    if (this.userType === 'teams') {
      const userCategory = this.user_data.category.category;
      this.plans = paymentPackagesLeague.filter((p) => p.league.includes(userCategory));
      [this.selectedPlan] = this.plans;
      this.selectedPlan.promoPrice = this.getRestPrice(this.selectedPlan);

      if (this.user_data.stripe_customer) {
        const { stripe_customer_id, ...restWithoutCustomerId } =
          this.user_data.stripe_customer;

        this.stripeCustomerId = stripe_customer_id;
        this.form = {
          ...restWithoutCustomerId,
        };
        this.formDisabled = true;
      }

      this.paymentMethods = [
        // { component: 'Card', icon: 'mastercard1', active: true },
        { component: 'Paypal', icon: 'paypal-alternative', active: true },
        { component: 'Iban', icon: 'banktransfer1', active: true },
        // { component: 'Sofort', icon: 'klarna-sofort1', active: false },
        { component: 'Giropay', icon: 'giropay1', active: true },
        { component: 'MobileApple', icon: 'applepay1', active: isIOS || isMacOs },
        { component: 'MobileGoogle', icon: 'googlepay1', active: isChrome },
      ];
    } else {
      this.plans = paymentPackages;
      this.selectedPlan = this.plans.find((p) => p.swipes === 25);

      this.paymentMethods = [
        { component: 'Paypal', icon: 'paypal-alternative', active: true },
        { component: 'Card', icon: 'mastercard1', active: true },
        // { component: 'Iban', icon: 'banktransfer1', active: true },
        // { component: 'Sofort', icon: 'klarna-sofort1', active: false },
        { component: 'Giropay', icon: 'giropay1', active: true },
        { component: 'MobileApple', icon: 'applepay1', active: isIOS || isMacOs },
        { component: 'MobileGoogle', icon: 'googlepay1', active: isChrome },
      ];
    }
  },

  mounted() {
    // scroll to the middle of plans div, to show selected plan in center
    this.$refs.plansWrapper.scrollLeft =
      (this.$refs.plansWrapper.scrollWidth - this.$refs.plansWrapper.clientWidth) / 2;
    this.$refs.form.validate();
  },
};
</script>
